import { render, staticRenderFns } from "./SteeringCommittee.vue?vue&type=template&id=25c40ca6&scoped=true&"
import script from "./SteeringCommittee.vue?vue&type=script&lang=js&"
export * from "./SteeringCommittee.vue?vue&type=script&lang=js&"
import style0 from "./SteeringCommittee.vue?vue&type=style&index=0&id=25c40ca6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c40ca6",
  null
  
)

export default component.exports